export default {
  main: {
    site_id: 18746850,
    enableWorldCup: true,
    title: "Terminal PRO",
    showBetBuilderSection: true,
    staffPassword: "2662692",
    enableWinterMode: false,
    terminalId: 26455,
    enableTicketTimer: true,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    enableDefaultHomeHeader: false,
    defaultTheme: "light",
    homeMediaSlides: [
      {
        type: "multiple",
        path: "/betting/prematch/all/multiples",
      },
      {
        type: "sport",
        path: "/betting/prematch",
      },
    ],
    websitePasswordHash: "57c22bad7ba79a2e264877bf0b4951169efae8afdf7857c7fea2983d95f6b3da",
    logoSize: "big",
    availableLanguages: {
      "@replace": true,
      eng: {
        short: "EN",
        name: "ENG",
        region: "UnitedKingdom",
        order: 2,
      },
      spa: {
        short: "ES",
        name: "Esp",
        region: "UnitedKingdom",
        order: 1,
      },
    },
  },
  env: {
    lang: "spa",
  },
  splitScreen: {
    enabled: false,
  },
  verticalHome: {
    grid: [["shortpages"], ["slider"], ["comp"], ["populargames"]],
    gridColumns: "1fr",
    // gridRows: "1.5fr 7fr 6fr 4fr",
    gridRows: "1.17fr 3fr 1.6fr 8.4fr",
  },
  home: {
    liveGamesCount: 10,
  },
  verification: {
    enabled: true,
    required: true,
    externalValidation: true,
    amountValidation: false,
    payerValidation: true,
    betPayment: false,
    betCreation: false,
    type: 'DNI',
    placeBetText: 'Input DNI and place a bet',
    apiFallbackTimeout: 30,
    apiTimeout: 10,
    defaultCountryCode: 'PER',
    partner: 'bonanza',
    enableDNIFormatting: true,
    docTypes: [
      {
        name: 'DNI',
        type: 'DNI',
        default: true,
      }
    ],
  },
  routes: [
        {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: 'betting/live/all',
      name: "Live",
      enabled: true,
    },
    {
      url: "betting/prematch/all",
      name: "Prematch",
      type: "sportsBook",
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
      ],
    },
    {
      url: "betting/results",
      name: "Results",
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18746850, tid: 22868, token: "co7BHQ==", currency: "PEN" },
  betslip: {
    enableBookingBet: true,
    enableBookingId: true,
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Lottery tickets",
      type: "lotteryTicket",
      hideOnRestrictMode: true,
    },
    {
      name: "Cash-out",
      type: "cashoutTicket",
      hideOnRestrictMode: true,
    }
  ]
};
